export const KEYWORDS_URL_QUERY_PARAMETER = "q"
export const RESOURCE_URL_QUERY_PARAMETER = "ia"
export const PUBLISHED_AT_DATETIME_FILTER_URL_QUERY_PARAMETER = "pdtf"
export const DURATION_FILTER_URL_QUERY_PARAMETER = "durf"
export const SORT_BY_FILTER_URL_QUERY_PARAMETER = "sb"
export const INPUT_FORM_SUBMIT_ACTION = "/search"
